/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as HXKLineLayerSpec } from '../../../../layer/preset/hxKLine/hxKLine';
import * as utils from '../../../../util';
import { BaseSpec, ILayerTypeSpec, createLayerProcessor } from '../baseProcessor';

export type Spec = BaseSpec;

type HXKLineLayerType = StandardChartLayerSpec & HXKLineLayerSpec & ILayerTypeSpec;

// 创建K线图编码验证器
const validateHXKLineEncoding = (layer: HXKLineLayerType): boolean => {
  return Array.isArray(layer.stocks) && layer.stocks.length > 0;
};

// K线图不使用标准数据类型验证器，因为它有特殊的数据结构
const validateHXKLineDataTypes = (layer: HXKLineLayerType): boolean => {
  const { stocks = [] } = layer;

  if (!stocks.length) {
    utils.logger.warn('warning', `The "${layer.type}" layer must have at least one stock`);
    return false;
  }

  // 根据文档要求进行数据类型检测
  let isValid = true;

  stocks.forEach((stock, index) => {
    // 检查股票代码
    if (!stock.code) {
      utils.logger.warn(
        'warning',
        `Invalid stock code at index ${index} in the "${layer.type}" layer`
      );
      isValid = false;
    }

    // 检查股票名称
    if (!stock.name || typeof stock.name !== 'string') {
      utils.logger.warn(
        'warning',
        `Invalid stock name at index ${index} in the "${layer.type}" layer`
      );
      isValid = false;
    }
  });

  return isValid;
};

// 创建并导出K线图处理器
export const hxKLine = createLayerProcessor<HXKLineLayerType>(
  'hxKLine',
  validateHXKLineEncoding,
  // 第三个参数传递数据验证函数，但由于我们不使用标准数据结构，我们传递一个始终返回true的函数
  () => true,
  // 在额外检查中执行自定义数据验证
  layer => {
    if (!validateHXKLineDataTypes(layer)) {
      layer.__isEncodingValid = false;
      utils.logger.warn('warning', `Data type check failed for "${layer.type}" layer`);
    }
  }
);
